/* eslint-disable */
import { makeStyles, RACCOLOR } from '@rentacenter/racstrap';


export const dofStyles = () => {
    const useClasses = makeStyles((theme) => ({


        [theme.breakpoints.between(375, 450)]: {
            fontSizeXSM: {
                fontSize: '11px'
            }

        },

        smartWizardList: {
            position: 'relative',
            paddingLeft: theme.typography.pxToRem(8),
            paddingRight: theme.typography.pxToRem(8),
            width: 'auto',
            // '&:after': {
            //   borderBottom: '2px solid #2179FE',
            //   content: '""',
            //   position: 'absolute',
            //   right: '-225%',
            //   width: '252%',
            //   top: '29%',
            // },
            // '&:last-child': {
            //   '&:after': {
            //     border: 'none',
            //   },
            // },
        },
        fontSize13: {
            fontSize: '13px'
        },

        // yyyy



        forfont: {
            fontFamily: 'OpenSans-bold !important',
            fontSize: "20px !important"
        },

        forspace: {
            width: '50%', justifyContent: 'center'
        },

        forjustify: {
            justifyContent: 'center !important',
            marginTop: '120px !important'
        },
        foralign: {
            marginTop: '20px'
        },

        //userInfo
        // flexBasis: {
        //   flexBasis: '0',
        // },
        // textAlignJustify: {
        //   textAlign: 'justify'
        // },

        // Approval Page

        forweeklyapproval: {
            fontSize: '17px !important',

            marginTop: '10px'
        },

        totalapprovalamount: {
            color: '#0dcaf0', marginTop: '10px', fontSize: '30px', fontFamily: 'OpenSans-bold !important'
        },

        topmargin: {
            marginTop: '30px'
        },


        labelmargintop: {
            marginTop: ' 15px',
            fontFamily: 'OpenSans-regular',
            '& p': {
                textAlign: 'left'
            }
        },

        forfontsize: {
            fontSize: '20px '
        },

        forblue: {
            color: '#2179FE'
        },
        opensansbold: {
            fontFamily: 'OpenSans-bold'

        },
        forheight: {
            height: '30 px !important'
        },
        bodycontainer: {
            // margin: ' 0% 23%',
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px',
            marginTop: '7%',
            '& input': {
                height: '30px'
            }
        },
        forheading: {
            fontWeight: 'bold', fontSize: "20px",
            fontFamily: 'OpenSans-bold'
        },
        // Dof Headers Classes 
        parentClass: {
            height: '65px',
            backgroundColor: '#2179FE'
        },


        fontWeight: {
            fontWeight: 'bold',
            fontSize: theme.typography.pxToRem(13),
        },
        appClass: {
            width: '100%',
            border: 'aliceblue',
            borderRadius: theme.typography.pxToRem(3),
            backgroundColor: 'aliceblue',
            overflow: 'hidden'
        },

        existCustTitle: {
            fontFamily: 'OpenSans-bold',
            fontSize: theme.typography.pxToRem(20),
            fontWeight: 'bold',
            textAlign: 'center'
        },

        fontSize23px: {
            fontSize: theme.typography.pxToRem(23)
        },
        topMargin: {
            marginTop: '40px'
        },

        floatCenter: {
            justifyContent: 'center !important',
            margin: '10px 0'
        },
        floatLeft: {
            justifyContent: 'left !important'
        },

        floatRight: {
            justifyContent: 'right !important'
        },

        displayFlex: {
            display: 'flex',
        },

        spaceBetween: {
            // display: 'flex',
            justifyContent: 'space-between',
            // alignItems: 'space-between'
        },
        marginLeftRight: {
            padding: '0 8px'
        },
        alignCenter: {
            textAlign: 'center',
        },
        cardPadding: {
            padding: '8% !important'
        }
        ,
        textBold: {
            fontSize: theme.typography.pxToRem(16),
            fontFamily: 'OpenSans-bold',
            color: '#000'
        },
        cardContainer: {
            borderRadius: '1rem',
            boxShadow: '0px 1px 4px 0 rgba(0,0,0,.074)',
            width: '100%',
            height: 'auto',
            padding: '3%',
            marginTop: '35px',
        },

        cardMargin: {
            marginTop: '23px !important'
        },

        marginTop8px: {
            marginTop: '8px'
        },

        marginTop16px: {
            marginTop: '16px'
        },

        titleMargin: {
            marginTop: '15px',
            marginBottom: '5px',
        },

        marginBottom: {
            marginBottom: '18px'
        },

        marginBottomforInput: {
            marginBottom: '8px !important',
            fontWeight: '400 !important',
            fontFamily: 'OpenSans-semibold !important',
            fontSize: '16px !important',
        },

        marginBottomforInput1: {
            marginBottom: '8px !important',
            fontWeight: '400 !important',
            fontFamily: 'OpenSans-semibold !important',
            fontSize: '16px !important',
            textAlign: 'left'
        },

        inputBoxHeight: {
            "& input": {
                height: '25px !important'
            }
        },

        inputBoxHeightForSelect: {
            "& div": {
                "& div": {
                    "& div": {
                        height: '20px !important',
                        paddingTop: '10px',
                        textAlign: 'left'
                    }
                }
            }
        },

        datePickerClass: {
            "& div": {
                "& label": {
                    marginBottom: '8px !important',
                    fontWeight: '400 !important',
                    fontFamily: 'OpenSans-semibold !important',
                    fontSize: '16px !important'
                }
            }
        },


        fontWeightForName: {
            fontFamily: 'OpenSans-bold !important',
            fontSize: theme.typography.pxToRem(25),
            fontWeight: 'bold !important'
        },

        existCustHead: {
            fontFamily: 'OpenSans-bold',
            fontSize: theme.typography.pxToRem(18),
            marginTop: '30px'
        },

        existCustHeadPayfone: {
            fontFamily: 'OpenSans-bold',
            fontSize: theme.typography.pxToRem(18),
            marginTop: '30px'
        },

        existCustTexts: {
            fontWeight: '900',
            fontSize: theme.typography.pxToRem(15),
            fontFamily: 'OpenSans-bold'
        },

        textAlignLeft: {
            textAlign: 'left'
        },

        textAlignCenter: {
            textAlign: 'center'
        },

        textAlignRight: {
            textAlign: 'right'
        },
        textAlignRightForAmount: {
            "& input": {
                textAlign: 'right'
            }
        },

        marginInputFields: {
            margin: '4px 0'
        },

        // For Create Customer CSS
        topMarginCreateCustomer: {
            marginTop: '65px'
        },
        dateFontSize: {
            fontSize: '13.5px',
        },

        btnDivMargin: {
            marginTop: '27px'
        },

        dollarClass: {
            paddingTop: "12.4px",
            paddingBottom: "7.5px",
            height: '40px !important',

        },

        headingForReview: {
            fontSize: theme.typography.pxToRem(18),
            fontWeight: 'bold',
            fontFamily: 'OpenSans-bold',
            margin: '15px 0'
        },

        spanClass: {
            fontFamily: 'OpenSans-bold',
            fontWeight: '600 !important',
        },

        marginLeft: {
            marginLeft: '10px'
        },

        textAlignJustify: {
            textAlign: 'justify'
        },
        flexBasis: {
            flexBasis: '0'
        },

        colorForReviewPage: {
            backgroundColor: '#ECF0F3 !important'
        },
        whiteColor: {
            backgroundColor: 'white !important'
        },

        blueColor: {
            color: '#2179FE !important'
        },

        textAlignRightforAmount: {
            '& input': {
                textAlign: 'right',
            },
        },


        // Wizard Styles 

        smartWizard: {
            overflow: 'hidden',
            justifyContent: 'space-between',
            position: 'relative',
            '&:after': {
                borderBottom: '2px solid #2179FE',
                content: '""',
                position: 'absolute',
                left: '30px',
                right: '30px',
                top: '20px',
                zIndex: '-1',
            },

        },

        flexBasis0: {
            flexBasis: '0% !important'
        },






        borderDone: {
            border: '3px solid #2179FE',
            borderColor: "#2179FE",
            borderRadius: '30px',
            color: `${RACCOLOR.WHITE}`,
        },


        paddingTop3: {
            paddingTop: '3px',
        },

        done: {
            // backgroundImage: `url(${completedIcon})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundColor: '#2179FE',
            color: 'transparent',
            borderColor: '#2179FE',
        },

        smartWizardListLinkActive: {
            textAlign: 'center',
            position: 'relative',
            marginRight: theme.typography.pxToRem(14),
            width: 'auto',
            color: `${RACCOLOR.DEEP_SKY_BLUE}`,
            cursor: 'pointer',
            fontFamily: 'OpenSans-semibold',
            fontSize: theme.typography.pxToRem(12),
            textDecoration: 'none',
        },

        basicInfoCardStyle: {
            backgroundColor: '#F5FAFD',
            padding: '4%',
            borderRadius: '2%',
            textAlign: 'left'
        },

        textHeading: {
            fontFamily: 'OpenSans-bold',
            color: '#2468FF',
            fontSize: '16px',
            marginTop: '30px'
        },
        mt40: {
            marginTop: '40px'
        },

        subHeading: {
            fontSize: '16px',
            fontFamily: 'OpenSans-bold'
        },
        inputContainerStyle: {
            padding: '10px',
            fontSize: '16px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '100%',
            // maxWidth: '200px',
            cursor: 'pointer',
            textAlign: 'left',
            backgroundColor: 'white',
            display: 'inline-block',
            marginTop: '12px'
        },

        datePickerWrapperStyle: {
            position: 'relative',
            zIndex: 1
        },
        calendarStyle: {
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: '0',
            zIndex: 1,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
        },
        labelStyle: {
            display: 'block',
            fontWeight: 'bold',
            marginTop: '3px',
            fontSize: '15px',
            textAlign: 'left'
        },
        tcpaselection: {
            marginTop: '25px',
            zIndex: 1,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '10px',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
        },
        tittleColor: {
            color: '#034694'
        },
        font16px: {
            fontSize: '16px'
        },
        boldFont: {
            fontFamily: 'OpenSans-bold',
            fontSize: theme.typography.pxToRem(20),
        },
        boldFont1: {
            fontFamily: 'OpenSans-bold',
        },
        marginTop10p: {
            marginTop: '10%'
        },
        marginTop20p: {
            marginTop: '20%'
        },
        regularFont: {
            fontFamily: 'OpenSans-regular',
            fontSize: theme.typography.pxToRem(14),
        },
        font16px: {
            fontSize: '16px'
        },
        font14px: {
            fontSize: '14px'
        },
        font18px: {
            fontSize: '18px'
        },
        blackFont: {
            color: 'black'
        },
        mt20px: {
            marginTop: '20px'
        },
        p16px: {
            padding: '16px'
        },
        p10px: {
            padding: '10px'
        },
        pl16px: {
            paddingLeft: '16px'
        },
        pt10px: {
            paddingTop: '10px'
        },
        pl35px: {
            paddingLeft: '35px'
        },
        pb5px: {
            paddingBottom: '5px'
        },
        pb10px: {
            paddingBottom: '10px'
        },
        pt0px: {
            paddingTop: '0px'
        },
        textAlignLeft: {
            textAlign: 'left'
        },
        primaryButtonColor: {
            background: '#0f99d685',
            backgroundColor: '#0f99d6',
            '&:hover': {
                backgroundColor: '#0079af',
            },
            '&:active': {
                backgroundColor: '#0079af',
            },
            '&.Mui-disabled': {
                backgroundColor: '#0f99d685'
            }
        },
        primaryFontColor: {
            color: '#034694'
        },
        width100p: {
            width: '100%'
        },
        centerAlign: {
            textAlign: 'center',
        },
        leftAlign: {
            textAlign: 'left',
        },
        formLabel: {
            marginBottom: '0.2rem',
            color: '#000',
            fontFamily: 'OpenSans-semibold',
            fontSize: theme.typography.pxToRem(14),
        },
        mt2: {
            marginTop: theme.typography.pxToRem(10),
        },
        mt3: {
            marginTop: theme.typography.pxToRem(25),
        },
        pb4: {
            paddingBottom: theme.typography.pxToRem(24),
        },
        mx1: {
            marginRight: theme.typography.pxToRem(4),
            marginLeft: theme.typography.pxToRem(4),
        },
        mobileFrame: {
            paddingTop: '10%'
        },
        tabFrame: {
            padding: '20%'
        },
        desktopFrame: {
            padding: '7%',
            paddingTop: '4%'
        },
        tabGridStyle: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
        },
        desktopGridStyle: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
        },
        tabButtonSize: {
            width: '35%',
            marginTop: '5%'
        },
        desktopButtonSize: {
            width: '15%',
            marginTop: '2%'
        },
        iframeContainer: {
            position: 'relative',
            width: '100%', // Full width
            overflow: 'hidden',
        },
        iframeStyling: {
            width: '100%',
            height: '100%',
            border: 'none',
        },
        iframeMobile: {
            // Adjust based on your design
            width: '100%',
            height: '80vh', // Adjust for smaller screens
        },
        iframeTab: {
            width: '100%',
            height: '70vh', // Adjust for tablets
        },
        iframeDesktop: {
            width: '100%',
            height: '70vh', // Adjust for desktops
        },
        red: {
            backgroundColor: 'red'
        },
        heading: {
            paddingTop: '10px',
            width: '80%',
            fontFamily: 'OpenSans-bold',
            fontSize: '18px',
            fontWeight: '700',
            lineHeight: '24.51px',
            textAlign: 'center',
            textUnderlinePosition: 'from-font',
            textDecorationSkipInk: 'none',
            color: '#034694'
        },
        intellicheckTypeHeading: {
            paddingTop: '10px',
            fontFamily: 'OpenSans-bold',
            fontSize: '18px',
            fontWeight: '700',
            lineHeight: '24.51px',
            textAlign: 'center',
            textUnderlinePosition: 'from-font',
            textDecorationSkipInk: 'none',
            color: '#034694'
        },
        headingWidth: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
        },
        underline: {
            textDecoration: 'underline'
        },
        cursorPointer: {
            cursor: 'pointer'
        },
        mt10px: {
            marginTop: '10px'
        },
        drapNDropStyling: {
            padding: 2,
            border: '2px dashed #0f99d6',
            borderRadius: 1,
            textAlign: 'center',
            marginBottom: 2,
            boxShadow: 'none'
        },
        mb15px: { marginBottom: '15px' },
        mr10px: { marginRight: '10px' },
        sideHeading: {
            fontFamily: 'Open Sans',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '21.79px',
            textAlign: 'center',
            textUnderlinePosition: 'from-font',
            textDecorationSkipInk: 'none',
        },
        gridOuterStyling: {
            border: '3px dashed #0f99d6',
        },
        maxWidth: {
            maxWidth: '697px'
        },
        minWidth: {
            minWidth: '697px'
        },
        buttonBorderColor: {
            border: '1px solid #0f99d6'
        },
        lightGreyColor: {
            color: '#A9ACB4'
        },
        w91p: {
            width: '95%'
        },
        mb20px: {
            marginBottom: '20px'
        },
        minWidth38p: {
            minWidth: '38%'
        },
        pl10px: {
            paddingLeft: '10px'
        },
        fileSizeColor: {
            color: '#707070'
        },
        buttonsPadding: {
            padding: '7px 20px'
        },
        p20px: {
            padding: '20px'
        },
        pl50px: {
            paddingLeft: '50px'
        },
        pl25px: {
            paddingLeft: '25px'
        },
        textAlignCenter: {
            textAlign: 'center'
        },
        otpInputClass: {
            '& input': {
                border: 'none', /* Remove the border */
                borderBottom: '1px solid #B9B9B9', /* Add bottom border */
                borderRadius: '0', /* Remove the border radius */
                textAlign: 'center', /* Center align the text */
                fontSize: '18px', /* Adjust font size */
                background: 'transparent',
                fontFamily: 'OpenSans-bold',
                transition: 'all 0.3s',
                marginTop: '10px',
                width: '25px',
                border: '1px solid #2468FF',
                borderRadius: '5px'
            },
            '& input:hover': {
                backgroundColor: 'transparent', /* Ensure hover styling is neutral */
            },

            '& input:focus': {
                outline: 'none', /* Remove default browser outline */
                backgroundColor: 'transparent', /* Override hover background if applied */
                background: 'transparent',
                border: 'none',
            },

            '& input:not(:focus):hover': {
                backgroundColor: 'transparent', /* Disable hover effect when not focused */
            },
        },
        removeFocus: {
            '& .MuiInputBase-root': {
                '&.Mui-focused': {
                    // Remove default focus border and shadow when focused
                    boxShadow: 'none',
                    borderBottom: '1px solid black', // Optional: customize border
                },
            }
        },
        timerStyle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
            marginBottom: '1rem', /* Adds space below the div */
        },
        timerDiv: {
            display: 'flex',
            alignItems: 'right',
        },
        lightGreyColor: {
            color: '#696969'
        },
        displayFlex: {
            display: 'flex'
        },
        spaceAround: {
            justifyContent: 'space-around'
        },
        errorMessageColor: {
            color: '#F72B2B',
            fontSize: '14px'
        },
        justifyContentCenter: {
            justifyContent: 'center'
        },
        successMessageColor: {
            color: '#0FF74D'
        },
        responsiveText: {
            display: 'block',
            lineHeight: 1.4,
            [theme.breakpoints.up('md')]: {
                display: 'inline-block',
                whiteSpace: 'normal',
            },
        },
        responsiveFont14px: {
            fontSize: '14px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '16px',
                width: '80%'
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '18px',
                width: '46%'
            },
        },
        responsiveFontTitle: {
            fontSize: '18px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '18px',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '20px',
            },
        },
        mt30px: {
            marginTop: '20px',
            [theme.breakpoints.up('sm')]: {
                marginTop: '20px',
            },
            [theme.breakpoints.up('md')]: {
                marginTop: '30px',
            },
        },
        mt100px: {
            marginTop: '100px',

        },
        flexDirectionColumn: {
            flexDirection: 'column'
        },
        responsiveText: {
            display: 'block',
            lineHeight: 1.4,
            [theme.breakpoints.up('sm')]: {
                width: '50%',
            },
            [theme.breakpoints.up('md')]: {
                display: 'inline-block',
                whiteSpace: 'normal',
            },
        },
        responsiveFontStyle: {
            fontSize: '14px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '16px',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '18px',
            },
        },
        listStyle: {
            listStyleType: "disc",
            margin: "0",
            paddingLeft: "20px",
            marginBottom: "19px",
            color: "#333",
        },
        startButtonWidth: {
            width: '80%',
            maxWidth: '200px',
        },
        openSansRegularFont: {
            fontFamily: 'OpenSans-regular'
        },
        listBottomStyle: { marginBottom: "12px", textAlign: "left", fontFamily: 'OpenSans-regular' },
        listBottomStyle2: { marginBottom: "8px", textAlign: "left", fontFamily: 'OpenSans-regular' },
        policyGridStyle: {
            fontSize: "0.8rem",
            textAlign: "center",
            marginTop: "30px",
            color: "#666",
            padding: '5px'
        },
        pl30px: {
            paddingLeft: '30px'
        },
        referenceContainer1: {
            display: 'block',
            width: '75%',
            margin: '0 auto',
            fontFamily: 'OpenSans-semibold',

        },
        referenceSection: {
            maxWidth: '1000px',
            margin: '0 auto',
            textAlignCenter: 'center'
        },
        manulEntry: {
            color: '#0f99d6',
            textDecoration: 'underline',
            cursor: 'pointer'

        },
        residenceManulEntry: {
            width: '100%',
            padding: '3%',
            margin: '0 auto'
        },
        buttonContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        maxWidth45p: {
            maxWidth: '45%'
        },
        responsiveWidth: {
            width: '49%',
            minWidth: '360px',
            margin: '0 auto'
        },
        pdfIconStyle: {
            width: "15px",
            height: "15px",
            [theme.breakpoints.down('xs')]: {
                marginTop: '2px',
                marginLeft: '2px',
            },
            [theme.breakpoints.up('sm')]: {
                marginTop: '2px',
                marginLeft: '5px',
            },
            [theme.breakpoints.up('md')]: {
                marginTop: '6px',
                marginLeft: '6px',
            }
        },
        spaceBetween: {
            justifyContent: 'space-between'
        },
        marginRight10p: {
            marginRight: '10%'
        },
        pl5px: {
            paddingLeft: '5px'
        },
        fontSize11px: {
            fontSize: '11px'
        },
        adjustableMH: {
            marginTop: '10px',
            fontSize: '11px',
            [theme.breakpoints.up('sm')]: {
                marginTop: '10px',
                fontSize: '11px'
            },
            [theme.breakpoints.up('md')]: {
                marginTop: '8px',
                fontSize: '13px'
            }
        },
        alignItemsCenter: {
            alignItems: 'center'
        },
        checkedColor: {
            color: 'green',
            "&.Mui-checked": {
                color: 'green',
            }
        },
        w50p: {
            width: '70%',
        },
        ml55px: {
            marginLeft: '55px'
        },
        widthSize: {
            width: '80%',
            [theme.breakpoints.down('xs')]: {
                width: '80%'
            },
            [theme.breakpoints.up('sm')]: {
                width: '80%'
            },
            [theme.breakpoints.up('md')]: {
                width: '80%',
                marginLeft: '-40px'
            }
        },
        customModal: {
            '& div': {
                '& div:nth-child(2)': {
                    '& div': {
                        maxWidth: '700px',
                        maxHeight: '900px',
                        height: '800px',
                    }
                },
            },
        },
        racdropdownleftalign: {
            '& div ': {
                '& div': {
                    textAlign: 'left'
                }
            }
        },
        p30px: {
            padding: '30px'
        },
        p6px0px: {
            padding: '6px 0px'
        },
        semiboldFont: {
            fontFamily: 'OpenSans-semibold',
        },
        ml10px: {
            marginLeft: '10px',
        },
        ml5px: {
            marginLeft: '5px',
        },
        mb20px: {
            marginBottom: '20px'
        },
        intellicheckIdType: {
            marginTop: '25px',
            '& div ': {
                '& div': {
                    textAlign: 'left'
                }
            }
        },
        IDTypeLabelName: {
            marginBottom: '10px'
        },
        referenceContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            padding: '20px',
            width: '100%',
            maxWidth: '600px',
            margin: '0 auto',
        },
        title: {
            fontSize: '2rem',
            color: '#2179FE',
        },
        subtitle: {
            fontSize: '1.5rem',
            color: '#000000',
        },
        text: {
            fontSize: '1rem',
            color: '#333333',
        },
        list: {
            padding: 0,
            textAlign: 'left',
        },
        note: {
            marginTop: '20px',
            fontSize: '0.9rem',
            color: '#666666',
        },
        checkboxLabel: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
        },
        checkbox: {
            marginRight: '10px',
        },
        startButton: {
            marginTop: '20px',
            padding: '10px 20px',
            fontSize: '1rem',
            color: '#ffffff',
            backgroundColor: '#007bff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
        },
        ml10px: {
            marginLeft: '10px',
        },
        resUploadImageBtn: {
            background: '#F0F8FF !important',
            color: '#2179FE !important',
            borderRadius: '50px',
            width: '150px'
        },
        pointer: {
            cursor: 'pointer'
        },
        displayFlex: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: '10px'
        },
        viewPdfBtnColor: {
            borderRadius: '5px',
            width: '25%',
            padding: '10px'
        },
        justifyContentSpaceAround: {
            justifyContent: 'space-around'
        },
        fontOpensansBold: {
            fontFamily: 'OpenSans-bold'
        },
        inputBoxHeightForRACSelect: {
            "& div": {
                "& div": {
                    "& div": {
                        paddingTop: '10px',
                        textAlign: 'left'
                    }
                }
            }
        },
        MUIDatePicker: {
            '& div': {
                '& div': {
                    '& div': {
                        width: '131% !important', // Default for mobile and desktop
                        height: '31px !important',
                        paddingBottom: '3px !important',
                        paddingTop: '2px',
                        '& div': {
                            justifyContent: 'flex-end',
                        },
                        // Small tablet - 600px to 960px
                        [theme.breakpoints.between(600, 960)]: {
                            width: '186% !important',
                        },
                        // Large tablet - 800px to 1280px
                        [theme.breakpoints.between(800, 1280)]: {
                            width: '250% !important',
                        },
                    },
                },
            },
        }

    }))
    return useClasses()
}